import React from "react";
import IosArrowRight from "react-icons/lib/io/android-arrow-forward";

export default function RightIcon(props) {
    return <IosArrowRight {...props} />;
}
